import {Alert, Box, Button, Stack, Typography} from "@mui/material";
import {BackLink} from "@/global/components/BackLink";
import KaspiLogo from "@/global/icons/KaspiLogo";
import {FreedomLogo} from "@/global/icons/FreedomLogo";
import type {MouseEvent} from "react";

interface Props {
    handleStartTransaction: (e: MouseEvent<HTMLButtonElement>) => void;
    returnFirstStep: () => void,
    loadingStartTransaction: boolean,
}

export function StartTransactionStep({returnFirstStep, loadingStartTransaction, handleStartTransaction}: Props) {

    return (
        <>
            <BackLink
                sx={{
                    alignSelf: 'flex-start',
                    fontSize: '18px',
                }}
                label={'Вернуться к вводу ИИН'}
                onClick={returnFirstStep}
            />
            <Stack
                width={{lg: '60%', xs: '100%'}}
                flexDirection={'column'}
                gap={3}
                sx={{
                    margin: '0 auto',
                    p: 6,
                    borderRadius: '16px',
                    background: '#F5F5F5',
                    gap: '16px'
                }}
            >
                <Stack gap={2}>
                    <Alert severity={'info'}>
                        С даты последнего экзамена не прошел месяц. Повторная попытка стоит 2490 тенге”
                    </Alert>
                    <Typography fontSize={'16px'}>
                        Платежная система:
                    </Typography>
                    <Box
                        sx={{
                            display: 'grid',
                            gridTemplateColumns: {xs: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)'},
                            gap: 2
                        }}
                    >
                        <Button
                            onClick={handleStartTransaction}
                            data-id={'kaspi'}
                            disabled={loadingStartTransaction}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                height: '100%',
                                cursor: 'pointer',
                                borderRadius: '12px',
                                border: '4px solid transparent',
                                padding: 4,
                                backgroundColor: 'rgb(235, 45, 41)',
                                transition: 'all 0.5s',
                                color: 'white',
                                '&:hover': {
                                    backgroundColor: 'rgb(195,38,34)',
                                },
                            }}
                        >
                            <KaspiLogo/>
                        </Button>
                        <Button
                            onClick={handleStartTransaction}
                            data-id={'freedom'}
                            disabled={loadingStartTransaction}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                borderRadius: '12px',
                                height: '100%',
                                border: '4px solid transparent',
                                backgroundColor: 'rgba(100,255,162)',
                                transition: 'all 0.5s',
                                padding: 4,
                                '&:hover': {
                                    backgroundColor: 'rgba(1,142,57)',
                                },
                            }}
                        >
                            <FreedomLogo/>
                        </Button>
                    </Box>
                </Stack>
            </Stack>
        </>
    );
}